import { computed, Ref } from '@vue/composition-api'
import { KisweInputType } from '../types'

const useKisweInput = (inputType: Ref<KisweInputType>) => {

  const isInputTypeDuration = computed(() => inputType.value === KisweInputType.Duration)
  const isInputTypeText = computed(() => inputType.value === KisweInputType.Text)
  const isInputTypeTextArea = computed(() => inputType.value === KisweInputType.TextArea)
  const isInputTypeEmail = computed(() => inputType.value === KisweInputType.Email)
  const isInputTypePassword = computed(() => inputType.value === KisweInputType.Password)
  const isInputTypeNumber = computed(() => inputType.value === KisweInputType.Number)
  const isInputTypeColor = computed(() => inputType.value === KisweInputType.Color)
  const isInputTypeAnyString = computed(() => isInputTypeText.value || isInputTypeTextArea.value ||
    isInputTypeEmail.value || isInputTypePassword.value || isInputTypeColor.value)

  return {
    isInputTypeDuration,
    isInputTypeText,
    isInputTypeTextArea,
    isInputTypeEmail,
    isInputTypePassword,
    isInputTypeNumber,
    isInputTypeColor,
    isInputTypeAnyString
  }
}

export default useKisweInput
